// extracted by mini-css-extract-plugin
module.exports = {"error":"styles_error__2_ZpP","title":"styles_title__2B53V","text":"styles_text__rUCL_"};